<template>
  <div v-if="visible" class="gx-ann-popup" @click.self="close">
    <div class="gx-ann-popup__panel" role="dialog" aria-modal="true" aria-label="公告中心">
      <div class="gx-ann-popup__head">
        <div class="gx-ann-popup__head-left">
          <h3 class="gx-ann-popup__head-title">公告中心</h3>
          <span class="gx-ann-popup__head-count">共 {{ total }} 条</span>
          <span v-if="unreadCount > 0" class="gx-ann-popup__head-badge">{{ unreadCount > 99 ? '99+' : unreadCount }} 条未读</span>
        </div>
        <button type="button" class="gx-ann-popup__close" aria-label="关闭" @click="close">×</button>
      </div>
      <div class="gx-ann-popup__filters">
        <div class="gx-ann-popup__tabs">
          <button
            v-for="t in typeTabs"
            :key="'type-' + t.value"
            type="button"
            class="gx-ann-popup__tab"
            :class="{ 'gx-ann-popup__tab--on': typeFilter === t.value }"
            @click="changeType(t.value)"
          >{{ t.label }}</button>
        </div>
        <div class="gx-ann-popup__tabs">
          <button
            v-for="t in readTabs"
            :key="'read-' + t.value"
            type="button"
            class="gx-ann-popup__tab"
            :class="{ 'gx-ann-popup__tab--on': readFilter === t.value }"
            @click="changeRead(t.value)"
          >{{ t.label }}</button>
        </div>
      </div>
      <div class="gx-ann-popup__body">
        <aside class="gx-ann-popup__side">
          <div v-if="listLoading && !list.length" class="gx-ann-popup__hint">公告加载中...</div>
          <div v-else-if="listError && !list.length" class="gx-ann-popup__hint">
            <p class="gx-ann-popup__hint-text">{{ listError }}</p>
            <button type="button" class="gx-ann-popup__retry" @click="retryList">重试</button>
          </div>
          <div v-else-if="!list.length" class="gx-ann-popup__hint">暂无公告</div>
          <template v-else>
            <button
              v-for="item in list"
              :key="item.id"
              type="button"
              class="gx-ann-popup__item"
              :class="{ 'gx-ann-popup__item--active': selectedId === item.id }"
              @click="select(item)"
            >
              <span class="gx-ann-popup__item-title">{{ item.title }}</span>
              <span class="gx-ann-popup__item-meta">
                <span class="gx-ann-popup__tag" :class="'gx-ann-popup__tag--' + (item.type || 'update')">{{ typeLabel(item.type) }}</span>
                <span v-if="item.important" class="gx-ann-popup__tag gx-ann-popup__tag--important">重要</span>
                <span v-if="!item.is_read" class="gx-ann-popup__dot"></span>
                <span class="gx-ann-popup__item-time">{{ formatTime(item.published_at || item.start_at) }}</span>
              </span>
            </button>
            <div v-if="listError" class="gx-ann-popup__hint">
              <p class="gx-ann-popup__hint-text">{{ listError }}</p>
              <button type="button" class="gx-ann-popup__retry" @click="retryList">重试</button>
            </div>
            <button v-if="list.length < total" type="button" class="gx-ann-popup__more" @click="loadMore">加载更多</button>
          </template>
        </aside>
        <section class="gx-ann-popup__main">
          <div v-if="detailLoading" class="gx-ann-popup__hint">内容加载中...</div>
          <div v-else-if="detailError" class="gx-ann-popup__hint">
            <p class="gx-ann-popup__hint-text">{{ detailError }}</p>
            <button type="button" class="gx-ann-popup__retry" @click="retryDetail">重试</button>
          </div>
          <template v-else-if="detail">
            <div class="gx-ann-popup__detail-meta">
              <span class="gx-ann-popup__tag" :class="'gx-ann-popup__tag--' + (detail.type || 'update')">{{ typeLabel(detail.type) }}</span>
              <span v-if="detail.important" class="gx-ann-popup__tag gx-ann-popup__tag--important">重要</span>
              <span class="gx-ann-popup__detail-time">{{ formatTime(detail.published_at || detail.start_at) }}</span>
            </div>
            <h2 class="gx-ann-popup__detail-title">{{ detail.title }}</h2>
            <div v-if="detail.cover_url" class="gx-ann-popup__cover">
              <img :src="detail.cover_url" alt="" />
            </div>
            <div class="gx-ann-popup__content" v-html="detail.content"></div>
          </template>
          <div v-else class="gx-ann-popup__hint">选择左侧公告查看内容</div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { announcementList, announcementDetail, announcementRead } from '../../api/main/announcement'

export default {
  name: 'AnnouncementPopup',
  props: {
    unreadCount: { type: Number, default: 0 }
  },
  data() {
    return {
      visible: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 50,
      listLoading: false,
      listError: '',
      listRequestId: 0,
      typeFilter: '',
      readFilter: 'all',
      typeTabs: [
        { value: '', label: '全部' },
        { value: 'update', label: '系统更新' },
        { value: 'activity', label: '活动' }
      ],
      readTabs: [
        { value: 'all', label: '全部' },
        { value: 'unread', label: '未读' }
      ],
      selectedId: null,
      detail: null,
      detailLoading: false,
      detailError: '',
      detailCache: {},
      detailRequestId: 0,
      readingIds: {}
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    open() {
      this.visible = true
      this.list = []
      this.total = 0
      this.page = 1
      this.listError = ''
      this.typeFilter = ''
      this.readFilter = 'all'
      this.selectedId = null
      this.detail = null
      this.detailError = ''
      this.detailCache = {}
      this.readingIds = {}
      this.fetchList(true)
    },
    close() {
      this.visible = false
      this.$emit('closed')
    },
    onKeydown(e) {
      if (this.visible && e.key === 'Escape') this.close()
    },
    typeLabel(type) {
      return type === 'activity' ? '活动' : '系统更新'
    },
    formatTime(ts) {
      if (!ts) return ''
      const raw = typeof ts === 'number' ? ts : String(ts).replace(' ', 'T')
      const d = new Date(typeof raw === 'number' && raw < 1e12 ? raw * 1000 : raw)
      if (isNaN(d.getTime())) return String(ts)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    changeType(value) {
      if (this.typeFilter === value) return
      this.typeFilter = value
      this.fetchList(true)
    },
    changeRead(value) {
      if (this.readFilter === value) return
      this.readFilter = value
      this.fetchList(true)
    },
    async fetchList(reset) {
      const requestId = ++this.listRequestId
      this.listLoading = true
      this.listError = ''
      if (reset === true) {
        this.page = 1
        this.list = []
        this.selectedId = null
        this.detail = null
        this.detailError = ''
        this.detailRequestId += 1
        this.detailLoading = false
      }
      try {
        const params = { page: this.page, page_size: this.pageSize }
        if (this.typeFilter) params.type = this.typeFilter
        if (this.readFilter === 'unread') params.unread_only = 1
        const res = await announcementList(params)
        if (requestId !== this.listRequestId) return
        if (res && res.code === 200) {
          const data = res.data || {}
          const rows = Array.isArray(data.list) ? data.list : []
          const known = new Set(this.list.map((row) => row.id))
          rows.forEach((row) => {
            if (!known.has(row.id)) {
              this.list.push(row)
              known.add(row.id)
            }
          })
          this.total = Number(data.total || 0)
          if (reset === true) {
            if (this.list.length) {
              this.select(this.list.find((row) => !row.is_read) || this.list[0])
            } else {
              this.selectedId = null
              this.detail = null
            }
          }
        } else {
          this.listError = (res && res.msg) || '加载失败'
        }
      } catch (e) {
        if (requestId !== this.listRequestId) return
        this.listError = '加载失败，请重试'
      } finally {
        if (requestId === this.listRequestId) this.listLoading = false
      }
    },
    retryList() {
      this.fetchList(!this.list.length)
    },
    loadMore() {
      if (this.listLoading || this.list.length >= this.total) return
      this.page += 1
      this.fetchList(false)
    },
    async select(item, force) {
      if (!item || !item.id) return
      this.selectedId = item.id
      this.detailError = ''
      if (this.detailCache[item.id] && !force) {
        this.detail = this.detailCache[item.id]
        this.detailLoading = false
        if (!item.is_read) await this.markRead(item)
        return
      }
      const requestId = ++this.detailRequestId
      this.detailLoading = true
      this.detail = null
      try {
        const res = await announcementDetail(item.id)
        if (requestId !== this.detailRequestId) return
        if (res && res.code === 200 && res.data) {
          this.detail = res.data
          this.detailCache[item.id] = res.data
          if (!item.is_read) await this.markRead(item)
        } else {
          this.detailError = (res && res.msg) || '公告加载失败'
        }
      } catch (e) {
        if (requestId !== this.detailRequestId) return
        this.detailError = '公告加载失败，请重试'
      } finally {
        if (requestId === this.detailRequestId) this.detailLoading = false
      }
    },
    retryDetail() {
      const item = this.list.find((row) => row.id === this.selectedId)
      if (item) this.select(item, true)
    },
    async markRead(item) {
      if (!item || !item.id || item.is_read || this.readingIds[item.id]) return
      this.readingIds[item.id] = true
      try {
        const res = await announcementRead({ id: item.id })
        if (res && res.code === 200) {
          item.is_read = true
          item.read_at = Math.floor(Date.now() / 1000)
          if (this.detail && this.detail.id === item.id) {
            this.detail.is_read = true
            this.detail.read_at = item.read_at
          }
          this.$emit('read')
        }
      } catch (e) {
        // 静默失败，保留未读状态
      } finally {
        delete this.readingIds[item.id]
      }
    }
  }
}
</script>

<style scoped>
.gx-ann-popup {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: rgba(10, 12, 24, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-ann-popup__panel {
  width: 1040px;
  max-width: 100%;
  height: 600px;
  max-height: calc(100vh - 80px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.gx-ann-popup__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #EEF1F7;
  flex-shrink: 0;
}
.gx-ann-popup__head-left {
  position: relative;
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.gx-ann-popup__head-badge {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 10px;
  height: 18px;
  padding: 0 7px;
  border-radius: 9px;
  background: #C8443C;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(200, 68, 60, 0.35);
}
.gx-ann-popup__head-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-ann-popup__head-count {
  font-size: 12px;
  color: #8A95B0;
}
.gx-ann-popup__close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #8A95B0;
  cursor: pointer;
}
.gx-ann-popup__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 24px;
  border-bottom: 1px solid #EEF1F7;
  flex-shrink: 0;
}
.gx-ann-popup__tabs {
  display: flex;
  gap: 4px;
  background: #F4F6FB;
  padding: 3px;
  border-radius: 8px;
}
.gx-ann-popup__tab {
  border: none;
  background: transparent;
  padding: 4px 12px;
  border-radius: 6px;
  font-family: inherit;
  font-size: 12px;
  color: #5A6478;
  cursor: pointer;
}
.gx-ann-popup__tab--on {
  background: #C8443C;
  color: #fff;
  font-weight: 600;
}
.gx-ann-popup__body {
  flex: 1;
  display: flex;
  min-height: 0;
}
.gx-ann-popup__side {
  width: 240px;
  flex-shrink: 0;
  border-right: 1px solid #EEF1F7;
  background: #FAFBFD;
  overflow-y: auto;
  padding: 8px;
}
.gx-ann-popup__item {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  border-left: 3px solid transparent;
  border-radius: 8px;
  background: transparent;
  padding: 10px 12px;
  margin-bottom: 4px;
  cursor: pointer;
  font-family: inherit;
}
.gx-ann-popup__item:hover { background: #F4F6FB; }
.gx-ann-popup__item--active {
  background: #FFF5F4;
  border-left-color: #C8443C;
}
.gx-ann-popup__item-title {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 600;
  color: #2A2A3E;
  line-height: 1.5;
}
.gx-ann-popup__item-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 11px;
  color: #A8B0C2;
}
.gx-ann-popup__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #C8443C;
  flex-shrink: 0;
}
.gx-ann-popup__item-time {
  margin-left: auto;
  flex-shrink: 0;
}
.gx-ann-popup__tag {
  font-size: 11px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 4px;
  background: #EEF1F7;
  color: #5A6478;
  flex-shrink: 0;
}
.gx-ann-popup__tag--update { background: rgba(64, 128, 255, 0.12); color: #3A6FE0; }
.gx-ann-popup__tag--activity { background: rgba(255, 122, 40, 0.12); color: #E06A1A; }
.gx-ann-popup__tag--important { background: rgba(220, 60, 60, 0.12); color: #C8443C; }
.gx-ann-popup__more {
  width: 100%;
  border: none;
  background: transparent;
  padding: 10px;
  font-size: 12px;
  color: #5A6478;
  cursor: pointer;
}
.gx-ann-popup__more:hover { color: #C8443C; }
.gx-ann-popup__main {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 24px 28px 32px;
}
.gx-ann-popup__detail-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.gx-ann-popup__detail-time {
  font-size: 12px;
  color: #A8B0C2;
  margin-left: auto;
}
.gx-ann-popup__detail-title {
  margin: 0 0 18px;
  font-size: 20px;
  font-weight: 700;
  color: #1A1A2E;
  line-height: 1.4;
}
.gx-ann-popup__cover {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
  background: #F3F5FA;
}
.gx-ann-popup__cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.gx-ann-popup__content {
  font-size: 14px;
  line-height: 1.8;
  color: #2A2A3E;
  word-break: break-word;
}
.gx-ann-popup__content ::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}
.gx-ann-popup__content ::v-deep p { margin: 0 0 12px; }
.gx-ann-popup__hint {
  padding: 48px 12px;
  text-align: center;
  font-size: 13px;
  color: #8A95B0;
}
.gx-ann-popup__hint-text { margin: 0 0 10px; }
.gx-ann-popup__retry {
  border: 1px solid #D8DEEA;
  background: #fff;
  border-radius: 8px;
  padding: 6px 16px;
  font-size: 13px;
  color: #5A6478;
  cursor: pointer;
}
@media (max-width: 720px) {
  .gx-ann-popup__panel { height: calc(100vh - 24px); }
  .gx-ann-popup__body { flex-direction: column; }
  .gx-ann-popup__side {
    width: 100%;
    max-height: 180px;
    border-right: none;
    border-bottom: 1px solid #EEF1F7;
  }
}
</style>
